module.exports = __webpack_public_path__ + "img/bosspack_dfod_dg.fce3b17b.png";